import { cx } from '@linaria/core';
import { useRef } from 'react';
import { props, wrapper } from './_truncate-lines.style.js';
import { useApplyMaxHeightWhenNecessary } from './hook.apply-max-height-when-necessary.js';
import { jsx } from 'react/jsx-runtime';
import { assertRefObject } from '../../functions/assert-ref-object.js';

/**
 * truncates content to at most the maximum amount of lines configured by props.
 *
 * truncation is guaranteed both with inline and block content across all
 * browsers. Safari, using a CSS-only solution, will fail to truncate lines if
 * given block content and will instead set the height of the container to 0.
 * This solution avoids this problem no matter the content provided.
 */
function TruncateLines({
  as,
  maxLines,
  ...props$1
}) {
  const internalRef = useRef(null);
  const ref = props$1.ref ?? internalRef;
  assertRefObject(ref);
  useApplyMaxHeightWhenNecessary({
    maxLines
  }, ref);
  const Comp = as ?? "div";
  return /*#__PURE__*/jsx(Comp, {
    ...props$1,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: ref,
    className: cx(wrapper, props$1.className),
    style: props.__override({
      maxLines
    }),
    children: props$1.children
  });
}

export { TruncateLines };
//# sourceMappingURL=_truncate-lines.js.map
